var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.993,
    x2: 322.783,
    y1: 235.429,
    y2: 577.331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2157,
    stopColor: "#b0e995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    stopColor: "#87e4bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    stopColor: "#6ee1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e0db"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#9ad57d",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    stopColor: "#51b482",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8679,
    stopColor: "#239f85",
    stopOpacity: 0.868
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119786"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.376,
    x2: 258.725,
    xlinkHref: "#lg1",
    y1: 372.913,
    y2: 474.263
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.341,
    x2: 196.119,
    xlinkHref: "#lg1",
    y1: 415.493,
    y2: 344.468
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.608,
    x2: 45.869,
    xlinkHref: "#lg1",
    y1: 386.977,
    y2: 446.83
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.406,
    x2: 275.589,
    xlinkHref: "#lg1",
    y1: 438.253,
    y2: 270.887
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.965,
    x2: 405.15,
    y1: 67.755,
    y2: 321.941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2969,
    stopColor: "#2bb9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#42a0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.534,
    x2: 125.504,
    xlinkHref: "#lg2",
    y1: 371.614,
    y2: 25.584
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.739,
    x2: 286.075,
    xlinkHref: "#lg2",
    y1: 264.123,
    y2: 193.478
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.009,
    x2: 310.609,
    y1: 120.089,
    y2: 210.69
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m355.954 287.443-89.226 29.233c-7.621 2.497-15.835 2.497-23.456 0l-89.226-29.233c-7.379-2.418-15.451-2.418-23.109 0l-95.405 30.118c-5.58 1.761-9.82 6.871-10.49 12.672l-18.527 160.451c-1.231 10.662 7.319 18.296 16.887 14.995l95.745-33.034c8.401-2.898 17.24-2.898 25.306 0l97.687 35.103c8.356 3.003 17.365 3.003 25.722 0l97.687-35.103c8.066-2.898 16.905-2.898 25.306 0l95.745 33.034c9.567 3.301 18.118-4.333 16.887-14.995l-18.527-160.451c-.67-5.801-4.91-10.911-10.49-12.672l-95.405-30.118c-7.66-2.418-15.732-2.418-23.111 0z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.468 317.561-95.405-30.118c-3.831-1.209-7.764-1.814-11.659-1.814l10.671 184.841c4.265 0 8.575.724 12.778 2.175l95.745 33.034c9.567 3.301 18.118-4.333 16.887-14.995l-18.527-160.451c-.669-5.801-4.91-10.911-10.49-12.672z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.861 507.748 97.687-35.103c4.036-1.45 8.262-2.175 12.527-2.175l-10.671-184.841c-3.895 0-7.758.604-11.45 1.814l-89.226 29.233c-3.808 1.248-7.767 1.872-11.728 1.872v191.451c4.344 0 8.686-.751 12.861-2.251z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 318.548c-3.961 0-7.92-.624-11.728-1.872l-89.226-29.233c-3.692-1.209-7.555-1.814-11.45-1.814l-10.672 184.841c4.265 0 8.492.724 12.527 2.175l97.687 35.103c4.175 1.5 8.516 2.251 12.861 2.251z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m390.854 472.645 95.745 33.035c9.568 3.301 18.118-4.333 16.887-14.995l-18.527-160.451c-.67-5.801-4.91-10.911-10.49-12.672l-95.405-30.118c-7.658-2.417-15.731-2.417-23.11 0l-89.226 29.233c-7.621 2.497-15.835 2.497-23.456 0l-89.226-29.233s32.757 52.716 51.959 71.323l125.95 125.95 33.593-12.071c8.066-2.9 16.905-2.9 25.306-.001z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m410.08 155.08c0 85.648-109.193 233.16-155.08 233.16s-155.08-147.511-155.08-233.16 69.432-155.08 155.08-155.08 155.08 69.432 155.08 155.08z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 155.08,
    fill: "url(#SVGID_7_)",
    r: 133.487
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.028 82.124c-19.336-20.409-46.694-31.141-77.028-31.141-58.596 0-104.097 45.501-104.097 104.097 0 30.333 10.732 57.691 31.14 77.028l124.325 124.326c47.13-46.867 100.745-135.495 103.581-196.388z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 155.08,
    fill: "url(#SVGID_9_)",
    r: 106.097
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.5ef900beb6f4fb5f71076b0908d80fc1.svg";
export { ForwardRef as ReactComponent };